<template>
  <div>
    <v-layout row wrap fill-height>
      <v-flex xs12 fill-height>
        <component
          :is="MediaStream.currentPlayer"
          :meta="meta"
          :consumer="consumer"
          @movieEnded="onMovieEnd"
        ></component>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import { mapGetters, mapState } from "vuex";
import MediaStreamPlayer from "../player/MediaStreamPlayer";
export default {
  name: "MediaStream",
  props: {
    meta: {
      type: Object,
      default: null,
    },
    previewMode: {
      type: Boolean,
      default: false
    },
    consumer: {
      type: Object,
      default: null
    }
  },
  components: {
    MediaStreamPlayer
  },
  data() {
    return {
      MediaStream: {
        currentPlayer: null,
        playerState: null,
      },
    };
  },
  computed: {

    ...mapGetters("player", {
      getScreenerConfig: "getScreenerConfig",
    }),
  },
  mounted() {
    this.resolveMediaStream();
  },
  methods: {
    async resolveMediaStream() {
      /**
       * 1. Resolve which player need to be used
       */
      //await this.resolvePlayerState();
      this.resolveCurrentPlayer(this.meta);
    },

    /**
     * Resolve player type
     */
    resolveCurrentPlayer(meta) {
      let player = 'MediaStreamPlayer';
      return this.MediaStream.currentPlayer = player;
    },

    /**
     * Load all the player configurationg from local browser or
     * global state
     */
    async resolvePlayerState() {
    //   let playerState = await this.getScreenerConfig(this.meta.screener_id);

    //   /**
    //    * If no any player state is found or preview mode is enabled
    //    * then dump the default state
    //    */
    //   if(!playerState || this.previewMode){
    //       let default_state             = this.DEFINES.PLAYER_CONFIG.SCREENER;
    //       default_state.screener_id     = this.meta.screener_id;
    //       await this.$store.dispatch("player/updateScreenerConfig",default_state)
    //       return this.MediaStream.playerState = default_state;
    //   }

    //   /**
    //    * Else use configured state
    //    */
    //   return this.MediaStream.playerState = playerState;
    },

    /**
     * Show/Hide loadermessages between the switching
     */
    showMessageBtwSwitching() {
      this.eventStatusBoard.active = true;
      this.eventStatusBoard.loading = true;
      this.eventStatusBoard.message = "Please wait while we are fetching your screening";
    },

    hideSwitchingMessage() {
      this.eventStatusBoard.active = false;
      this.eventStatusBoard.loading = false;
      this.eventStatusBoard.message = null;
    },

    async onMovieEnd(previousPlayerState) {

    },
  },
};
</script>
<style scoped>
</style>
